import { Component, OnInit } from '@angular/core';
import { VendorService } from 'src/app/services/core/quickbook/vendors/vendor.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { debounceTime, filter, Subject } from 'rxjs';

@UntilDestroy()

@Component({
  selector: 'app-vendors-list',
  templateUrl: './vendors-list.component.html',
  styleUrls: ['./vendors-list.component.css']
})
export class VendorsListComponent implements OnInit {
  vendors: any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any = '';
  private searchSubject = new Subject<string>();
  vendorDetail: any;
  editingVendor: any;
  selectedDropdownIndex: any;
  toggleActionButtons = false;

  constructor(
    private vendorService: VendorService
  ) { }

  ngOnInit() {
    this.initializeSearch();
    this.getAllVendors(this.currentPage);
  }

  getAllVendors(page: any) {
    let queryParams: any = {
      limit: this.numberOfRecords,
      page
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.vendorService.getVendors(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.vendors = data.results;
            this.totalPages = data.totalPages;
            this.totalResults = data.totalResults;
          }
        },
        error: (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      });
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllVendors(page);
  }

  async onSyncVendor(vendor: any, type: any) {
    const pull = `Are you sure you want to overwrite vendor data with QuickBooks data?`
    const push = 'Are you sure you want to overwrite the QuickBooks data with vendor data'
    const result = await sweetAlert('Alert', type === 'pull' ? pull : push, 'warning', 'Yes', 'No');

    if (result.value) {
      if (type === 'pull') vendor.pulling = true; else vendor.pushing = true;
      const queryParams = {
        isSyncFrom: type === 'pull' ? true : false
      }

      this.vendorService.syncVendor(vendor.id, queryParams).subscribe(
        {
          next: (data: any) => {
            this.getAllVendors(this.currentPage);
            sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
          },
          error: (err) => {
            sweetAlert('Error', err, 'error', 'Ok');
            vendor.pulling = false;
            vendor.pushing = false;
          },
          complete: () => {
            vendor.pulling = false;
            vendor.pushing = false;
          }
        })
    }
  }

  openDetailModal(vendor: any) {
    this.vendorDetail = vendor;
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getAllVendors(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  openEditModal(vendor: any) {
    this.editingVendor = vendor;
  }

  onCloseModal() {
    this.editingVendor = null;
  }

  onSaveModal(vendor: any) {
    if (vendor) {
      this.getAllVendors(this.currentPage);
    }
    this.editingVendor = null;
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }
}
